module.exports = __webpack_public_path__ + "static/media/dread_cleaver.8d52bf59.png";